interface HealthDisclaimerProps {
  variant?: "inline" | "box";
}

export default function HealthDisclaimer({ variant = "inline" }: HealthDisclaimerProps) {
  if (variant === "box") {
    return (
      <div className="bg-secondary-100 border border-secondary-200 rounded-lg p-4 md:p-5">
        <p className="font-body text-xs md:text-sm text-foreground-600 leading-relaxed">
          <strong className="text-foreground-800">Important note:</strong>{" "}
          Serena&apos;s Quiet Recovery Space provides supportive coaching and educational resources.
          It is not a clinical treatment programme, medical service, or substitute for professional
          medical advice, diagnosis, or treatment. If you are physically dependent on alcohol or
          concerned about withdrawal symptoms, please consult a qualified healthcare professional
          before making changes to your drinking. If you need immediate help, contact your GP,
          NHS 111, or in an emergency call 999.
        </p>
      </div>
    );
  }

  return (
    <p className="font-body text-xs text-foreground-500 leading-relaxed">
      <strong className="text-foreground-600">Important:</strong>{" "}
      This is a supportive coaching and educational space, not a clinical or medical service.
      If you are physically dependent on alcohol, please seek professional medical advice before
      making changes to your drinking.
    </p>
  );
}